import SidebarLinks from '../SideNavigationPanel/SidebarLinks';
import { NavigationItemsProps } from './interface';

export const MainNavigationItems = (props: NavigationItemsProps) => {
  const { items, pathname, search, linkClickHandler } = props;
  return (
    <>
      {items.map(item => (
        <SidebarLinks
          key={item.key}
          activeIcon={item.activeIcon}
          inActiveIcon={item.inActiveIcon}
          name={item.name}
          route={item.route}
          subRoute={item.subRoute}
          activeQueryParam={item.activeQueryParam}
          linkClickHandler={linkClickHandler}
          currentPathname={pathname}
          currentSearch={search}
          clickStreamEvent={item.clickStreamEvent}
          component={item.component}
        />
      ))}
    </>
  );
};

export default MainNavigationItems;
